import React, { Fragment } from "react";
import Login, { LoginMode } from "../../login/login";
var CodeRedeemAuth = function CodeRedeemAuth() {
    return /*#__PURE__*/ React.createElement(Fragment, null, /*#__PURE__*/ React.createElement("h1", {
        className: "text-5xl font-light leading-tight pl-8 pb-8"
    }, "Melden Sie sich an", /*#__PURE__*/ React.createElement("br", null), " oder erstellen Sie einen Account"), /*#__PURE__*/ React.createElement(Login, {
        initialMode: LoginMode.REGISTER
    }));
};
export default CodeRedeemAuth;
